import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import configSlice from "./slice/configSlice";
import tagsSlice from "./slice/tagsSlice";

export const store = configureStore({
    reducer:{
        configSlice,
        userSlice,
        tagsSlice
        }
});